import type { JSX } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Screen } from "../components/ui/editorial/Screen.js";
import { Topline } from "../components/ui/editorial/Topline.js";
import { PrimaryButton } from "../components/ui/editorial/PrimaryButton.js";

export function Consent(): JSX.Element {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);

  return (
    <Screen tone="paper">
      <div className="px-[22px] pt-[48px]">
        <Topline left="COMPANION" right="условия" />
      </div>

      <div className="flex flex-1 flex-col px-[22px] pt-[38px]">
        <div className="editorial-kicker text-accent">Прежде чем начать</div>

        <h2 className="mt-[18px] font-display font-light leading-[1.02] tracking-[-0.02em] text-ink text-[42px]">
          Коротко о <em className="italic text-velvet">правилах</em>.
        </h2>

        <div className="mt-[24px] font-display font-light text-[16px] leading-[1.55] text-ink/80 space-y-[14px]">
          <p>
            Мы собираем минимум — только то, что помогает Спутнику подобрать вам правильного
            человека.
          </p>
          <p>
            Никаких свайпов, продажи данных третьим лицам и автосписаний. Паузу можно поставить в
            любой момент.
          </p>
        </div>

        <div className="mt-[26px] space-y-[12px]">
          <Link
            to="/privacy"
            className="flex items-baseline justify-between border-t border-ink/12 py-[14px] text-ink hover:opacity-80"
          >
            <span className="font-display font-light text-[18px]">Политика приватности</span>
            <span className="editorial-meta text-accent">читать</span>
          </Link>
          <Link
            to="/terms"
            className="flex items-baseline justify-between border-t border-b border-ink/12 py-[14px] text-ink hover:opacity-80"
          >
            <span className="font-display font-light text-[18px]">Пользовательское соглашение</span>
            <span className="editorial-meta text-accent">читать</span>
          </Link>
        </div>

        <label className="mt-[24px] flex cursor-pointer items-start gap-[12px] select-none">
          <span
            className={`mt-[3px] flex h-[18px] w-[18px] flex-none items-center justify-center rounded-[4px] border transition-colors ${
              accepted ? "bg-ink border-ink" : "border-ink/40 bg-transparent"
            }`}
            aria-hidden
          >
            {accepted && (
              <svg
                width="10"
                height="8"
                viewBox="0 0 10 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 4L3.8 6.5L9 1"
                  stroke="#f5efe4"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </span>
          <input
            type="checkbox"
            className="sr-only"
            checked={accepted}
            onChange={(e) => {
              setAccepted(e.target.checked);
            }}
          />
          <span className="font-display font-light text-[15px] leading-[1.45] text-ink/80">
            Я прочитал и согласен с Политикой приватности и Пользовательским соглашением.
          </span>
        </label>
      </div>

      <div className="px-[22px] pb-[24px] pt-[16px]">
        <PrimaryButton
          disabled={!accepted}
          onClick={() => {
            navigate("/basics");
          }}
        >
          Продолжить
        </PrimaryButton>
      </div>
    </Screen>
  );
}
